export enum FeatureFlag {
  GP_OPPORTUNITY_SHOW_MINIMUM_INVESTMENT_OVERRIDE = "gp_opportunity_show_minimum_investment_override",
  HIDE_EMPLOYEE_IMPERSONATION_ENTRY = "temporary_adjustment_hide_employee_impersonation_entry",
  USE_GET_USER_FUND_DOCUMENT_FILTERS_V2 = "use_get_user_fund_document_filters_v2",
  GP_FUND_INVESTMENT_DETAILS_V2 = "gp_fund_investment_details_v2",
  GP_ORG_INVESTMENT_DEEPDIVE = "gp_org_investment_deepdive",
  GP_ORG_OFFERING_DEEPDIVE = "gp_org_offering_deepdive",
  GP_ENTITY_RELATIONSHIP_GRAPH = "gp_entity_relationship_graph",
  GP_INVESTMENT_METRIC_ADJUSTMENTS = "gp_investment_metric_adjustments",
  GP_TRIGGER_DOCS_NOTIFICATIONS = "gp_trigger_docs_notifications",
  GP_TRIGGER_OFFERING_DOCS_NOTIFICATIONS = "gp_trigger_offering_docs_notifications",
  GP_REPORTING_NOTIFY_ALL_DOCUMENT_TYPES = "gp_reporting_notify_all_document_types",
  GP_ANALYTICS = "gp_analytics",
  GP_ANALYTICS_SUBSCRIPTIONS = "gp_analytics_subscriptions",
  GP_USERS_RESEND_INVITATIONS = "gp_users_resend_invitations",
  GP_RETRIGGER_EMAIL = "gp_retrigger_email",
  GP_ORGS_LINKED_USERS = "gp_orgs_linked_users",
  GP_SETTINGS_INVITE_COLLABORATORS = "gp_settings_invite_collaborators",
  GP_API_GATEWAY_WORKBENCH_KEY_MANAGEMENT = "gp_api-gateway_workbench-key-management",
  GP_CASE_MANAGEMENT = "gp_case_management",
  GP_CO_INVESTMENT = "gp_co_investment",
  COINVEST_DATA_ROOM_VD_22599 = "coinvest_data_room_vd_22599",
  COINVEST_BOOK_BUILD_VD_26153 = "coinvest_book_build_vd_26153",
  COINVEST_REPORTING_VD_26152 = "coinvest_reporting_vd-26152",
  COINVEST_INSIGHTS_VD_26155 = "coinvest_insights_vd-26155",
  COINVEST_OUTREACH_EMAIL_VD_27885 = "coinvest_outreach_email_vd-27885",
  COINVEST_NOTIFICATIONS = "coinvest_notifications",
  COINVEST_MESSAGING_VD_28584 = "coinvest_messaging_vd-28584",

  FUND_OPPORTUNITIES_PAGE_V2 = "fund_opportunities_page_v2",
  LP_SETTINGS_TAB_SECURITY = "lp_settings_tab_security",
  LP_SETTINGS_RESEND_INVITATIONS = "lp_settings_resend_invitations",
  LP_MANAGE_INVESTMENT_USERS = "lp_manage_investment_users",
  LP_MANAGE_FUND_USERS = "lp_manage_fund_users",
  LP_CO_INVESTMENT_UI = "lp_co_investment_ui",
  LP_HOME_V2 = "lp_home_v2",
  LP_CAPITAL_ACTIVITY_TABLE_V2 = "lp_capital_activity_table_v2",
  LP_CAPITAL_ACTIVITY_SORTING = "lp_capital_activity_sorting",
  LP_CAPITAL_ACTIVITY_INVESTING_ENTITY_LABEL = "lp_capital_activity_investing_entity_label",
  LP_REPORTING_V2 = "lp_reporting_v2",
  LP_EDV_ENABLED = "lp-edv-enabled",
  LP_EDV_PRE_INVESTMENT_ENABLED = "lp-edv-pre-investment-enabled",
  LP_EDV_1D_CHANGE_ENABLED = "lp-edv-1d-change-enabled",
  LP_EDV_7D_CHANGE_ENABLED = "lp-edv-7d-change-enabled",
  LP_AUTH_LOGIN_TASK = "lp_auth_login_task",
  LP_INVESTOR_DOCUMENTS_V2 = "lp_investor_documents_v2",
  LP_SUBSCRIPTION_OFFLINE_SUBMISSION_ENABLED = "lp_subscription_offline_submission_enabled",
  LP_SUBSCRIPTION_SUBMIT_TO_REVIEW_PRIOR_SIGNING_ENABLED = "lp_subscription_submit_to_review_prior_signing_enabled",
  LP_SUPPORT_TICKET_SUBMISSION = "lp_support_ticket_submission",
  LP_CASE_MANAGEMENT = "lp_case_management",
  LP_AI_CHAT = "lp_ai_chat",
  LP_OFFERINGS_FILTER_CONSISTENCY = "lp_offerings_filterconsistency",
  LP_OFFERINGS_COLUMN_SORT = "lp_offerings_sort",
  ALPHA_2_CODE_SUPPORT = "subscription_alpha2_code_country_output_enabled",
  MAINTENANCE_MODE = "maintenance_mode",
  FOUR_EYES_APPROVAL_FOR_OPPORTUNITY_INVITE = "four_eyes_approval_for_opportunity_invite",
  DEVICE_MANAGEMENT = "device_management",
  ALLOW_FORCE_PUBLISH_TEMPLATES = "allow_force_publish_templates",
  SPIKE_NEW_AUTH = "spike_new_auth",
  LP_ORGANIZATION_URL_SYNC = "lp_organization_url_sync",
  LP_ORG_SWITCHER_ALL_PAGES = "lp_org_switcher_all_pages",
  SUBSCRIPTION_DEPRECATE_APOLLO_EMPLOYEE_QUESTION = "subscription_deprecate_apollo_employee_question",
  SUBSCRIPTIONS_INSTITUTIONAL_PREFILL_ENABLED = "subscriptions_institutional_prefill_enabled",
  NOTIFICATIONS_COMMENTS_V2 = "notifications_comments_v2",
  BE_CLOSING_DATE_SELECTION = "be_closing_date_selection",
  LP_HIDE_NULLISH_INVESTMENTS_2 = "lp_hide_nullish_investments_2",

  VEGA_CMS_MIGRATION = "paul_cms_migration",
  CMS_CONTENT_VERSIONING = "cms_content_versioning",
  SUBSCRIPTION_TEMPLATES_NEW_UQLS = "subscription_templates_new_uqls",
  DOC_CLASSIFICATION_ENABLED = "doc_classification_enabled",
  INVITE_USERS_MODAL_V2 = "invite_users_modal_v2",
  GP_COLLABORATORS_V2 = "gp_collaborators_v2",
  GP_SUPPORT_PLATFORM_QUESTIONS = "gp_support_platform_questions",
  FUND_MANAGEMENT_V2_ENDPOINTS = "fund_management_v2_endpoints",
  GP_INTERNAL_NOTES_MENTION = "gp_internal_notes_mention",
  GP_INGESTION_V2_POLLING = "gp_ingestion_v2_polling",
  GP_NAVIGATION_HELPER = "gp_navigation_helper",
  GP_HOME_TAB = "gp_home_tab",
  GP_AUTH_ENDPOINT_SPLIT = "gp_auth_endpoint_split",
  GP_AUTH_UI_CAPABILITIES = "gp_auth_ui_capabilities",
  GP_AUTH_INVITATION_V2 = "gp_auth_invitation_v2",
  GP_UNSENT_COMMENTS_WARNING = "gp_unsent_comments_warning",
  GP_QUESTIONNAIRE_NAVIGATION_V2 = "gp_questionnaire_navigation_v2",
  GP_AUTH_EMAIL_PREVIEW = "gp_auth_email_preview",
  GP_COMMENT_MAPPING = "gp_comment_mapping",
  GP_FUND_INVESTMENT_HEADER_V2 = "gp_fund_investment_header_v2",
  GP_NOTIFICATIONS_CENTER = "gp_notifications_center",
  LP_CMS_IN_APP_NOTIFICATION = "lp_cms_in_app_notification",
  GP_RECONCILIATION = "gp_reconciliation",
  GP_COMMS_NOTIFICATION_HUB = "gp_comms_notification_hub",
  GP_COINVEST_NEW_UI_NAV_VD_25769 = "gp_coinvest_new_ui_nav_vd-25769",
  GP_SUBSCRIPTIONS_TRACKER = "gp_subscriptions_tracker",
  GP_SUBSCRIPTIONS_TRACKER_OVERVIEW_V2 = "gp_subscriptions_tracker_overview_v2",
  GP_SUBSCRIPTIONS_TRACKER_V2 = "gp_subscriptions_tracker_v2",
  GP_MANUAL_SUBMISSION = "gp_manual_submission",
  GP_WORKBENCH_CHANGELOG = "gp_workbench_changelog",
  GP_INGESTION = "gp_ingestion",
  GP_FUND_MANAGEMENT_GAIA = "gp_fund_management_gaia",
  GP_FUND_MANAGEMENT_GAIA_V2 = "gp_fund_management_gaia_v2",
  GP_FUND_MANAGEMENT_FUND_BY_ID_V2 = "gp_fund_management_fund_by_id_v2",
  GP_FUND_MANAGEMENT_FUND_LIST_V2 = "gp_fund_management_fund_list_v2",
  GP_GAIA_FUND_LIST_NAV = "gp_gaia_fund_list_nav",
  GP_WORKBENCH_DOCUMENTS = "gp_workbench_documents",
  GP_INTELLIGENCE_SERVICE = "gp_intelligence_service",
  GP_WORKFLOW_TASK_ASSIGNMENT = "gp_workflow_task_assignment",
  GP_APPROVAL_HISTORY_V2 = "gp_approval_history_v2",
  GP_REPORTING_INQUIRY = "gp_reporting_inquiry",
  GP_FUND_DOCUMENT_UPLOAD = "gp_fund_document_upload",
  LP_HOMEPAGE_ASSETCLASSES = "lp_homepage_assetclasses",
  GP_DOCUMENT_DEEPLINK_GENERATION = "gp_document_deeplink_generation",
  LP_HOME_DYNAMIC_FILTERS = "lp_home_dynamic_filters",
  LP_CAPACT_FILTER_MULTISELECT = "lp_capact_filter_multiselect",
  LEGAL_ENTITIES_CRUD_OPS = "ledger_legal_entities_crud_ops",
}
